import Head from 'next/head'
import { useContext } from 'react'

import { useUserService } from '@lib/hooks'
import { useSessionData } from '@lib/hooks/use-session-data'

import { PixelTrackerContext } from '@contexts/pixel-tracker-context'

interface ExperimentAssignmentPixelProps {
  isPreview?: boolean
}

/**
 * Server-side pixel injection component for experiment tracking
 * Renders tracking pixel during SSR only, prevents client-side hydration changes
 */
export function ExperimentAssignmentPixel({ isPreview }: Readonly<ExperimentAssignmentPixelProps>) {
  const pixelTracker = useContext(PixelTrackerContext)
  const { containerId } = useSessionData()
  const { currentUser } = useUserService()

  // Pixel URL will be null on client-side since tracking only happens during SSR
  const pixelUrl = pixelTracker.generatePixelUrl({
    isPreview,
    containerId,
    userId: currentUser?.id,
  })

  if (!pixelUrl) {
    return null
  }

  return (
    <Head>
      <script key="experiment-assignment-tag" suppressHydrationWarning src={pixelUrl} />
    </Head>
  )
}
